module.exports = __webpack_public_path__ + "img/UTCAMP-3.1c4912f9.jpg";